<!-- text block -->

@if (block.type === 'text' && block.primitiveContent) {
  <div class="rtf">
    <p><span class="skeleton">{{ block.primitiveContent }}</span></p>
  </div>
}

<!-- rtf block -->
@if (block.type === 'rtf' && block.primitiveContent) {
  <div class="rtf" handle-external-links [innerHTML]="block.primitiveContent | bypassSecurityTrustHtml"></div>
}

<!-- image block -->
@if (block.type === 'images') {
  <!-- single image block -->
  @if (block.mediaItems.length === 1) {
    <proto-image imageType="default" class="single-image"
      [imageUrl]="block.mediaItems[0].src"
      (imageClicked)="openImage($event)">
      @if (block.mediaItems[0].title || block.mediaItems[0].description || block.mediaItems[0].copyright) {
        <div class="proto-image-content">
          <div class="image-caption">
            @if (block.mediaItems[0].title) {
              <h3 class="image-caption__title">{{ block.mediaItems[0].title }}</h3>
            }

            @if (block.mediaItems[0].description) {
              <p class="image-caption__description">{{ block.mediaItems[0].description }}</p>
            }

            @if (block.mediaItems[0].copyright) {
              <small class="image-caption__copyright">{{ block.mediaItems[0].copyright }}</small>
            }
          </div>
        </div>
      }
    </proto-image>
  } @else {
    <!-- gallery block -->
    <div class="horizontal-swiper-wrapper">
      <!-- only show swiper navigation buttons if we have more than 3 items -->
      @if (block.mediaItems.length > 3) {
        <div class="swiper-nav-buttons">
          <ion-button class="swiper-nav-button swiper-nav-button-prev--{{block.id}}" fill="clear" shape="round">
            <ion-icon name="chevron-back-circle-outline" slot="icon-only"></ion-icon>
          </ion-button>
          <ion-button class="swiper-nav-button swiper-nav-button-next--{{block.id}}" fill="clear" shape="round">
            <ion-icon name="chevron-forward-circle-outline" slot="icon-only"></ion-icon>
          </ion-button>
        </div>
      }
      <swiper-container
        *ngIf="swiperDirectiveWorkaround"
        [modules]="swiperOptions.modules"
        [slidesPerView]="'auto'"
        [centeredSlides]="true"
        [centeredSlidesBounds]="true"
        [breakpoints]="swiperOptions.breakpoints"
        [navigation]="{ nextEl: '.swiper-nav-button-next--' + block.id, prevEl: '.swiper-nav-button-prev--' + block.id  }"
        class="horizontal-swiper">
        @for (item of block.mediaItems; track $index) {
          <swiper-slide>
            <proto-image imageType="detail"
              [imageUrl]="item.imageId.id"
              (imageClicked)="openImage($event)">
              @if (item.title || item.description || item.copyright) {
                <div class="proto-image-content">
                  <div class="image-caption">
                    @if (item.title) {
                      <h3 class="image-caption__title">{{ item.title }}</h3>
                    }
                    @if (item.description) {
                      <p class="image-caption__description">{{ item.description }}</p>
                    }
                    @if (item.copyright) {
                      <small class="image-caption__copyright">{{ item.copyright }}</small>
                    }
                  </div>
                </div>
              }
            </proto-image>
          </swiper-slide>
        }
      </swiper-container>
    </div>
  }
}

<!-- external externalLink block -->
@if (block.type === 'external' && block.externalLink && block.externalLink.title) {
  <ion-button class="proto-button external-link" expand="block"
    [color]="block.externalLink.color || 'primary'"
    (click)="openUrl(block.externalLink?.href)">
    {{ block.externalLink.title }}
  </ion-button>
}

<!-- file download block -->
@if (block.type === 'files') {
  @for (item of block.mediaItems; track $index) {
    <ion-button class="proto-button external-link" expand="block" fill="outline" color="primary"
      (click)="openUrl(item.src)">
      @if (item.mimeType?.endsWith('pdf')) {
        <ion-icon name="document-text-outline"></ion-icon>
      } @else {
        <ion-icon name="download-outline"></ion-icon>
      }
      {{ item.title }}
    </ion-button>
  }
}

<!-- TODO: add audio -->

<!-- TODO: add video component to blueprint check issue #65 -->
